import { render } from "./portfolio.vue?vue&type=template&id=316144d7&scoped=true"
import script from "./portfolio.vue?vue&type=script&lang=js"
export * from "./portfolio.vue?vue&type=script&lang=js"

import "./portfolio.vue?vue&type=style&index=0&id=316144d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316144d7"]])

export default __exports__